import React from 'react';

import ContractItem from './ContractItem';
import ContractOffer from './ContractOffer';

class ContractSelection extends React.Component {

	constructor(props) {
		super(props);

		this._handleChange = this._handleChange.bind(this);
	}
  
	_handleChange(contractOption) {
		this.props.onContractSelectionChanged(contractOption);
	}

	_hasContracts() {
		return (this.props.contractOptionList == undefined || this.props.contractOptionList.length < 1) ? false : true;
	}

	_hasChangableContract() {
		return (this.props.contractOptionList == undefined || this.props.contractOptionList.length < 2) ? false : true;
	}

	_renderItem(contracts){
		var displayClass = contracts._hasChangableContract() ? '' : 'd-none';
	
		var contractOffers = contracts.props.contractOptionList.map(function(contractOption){
			return <ContractOffer key={contractOption.Key} contractOption={contractOption} />;
		});

		var arbitraryStyle = { width: '100%' };

		var contractItems = contracts.props.contractOptionList.map(function(contractOption, index){
			if (contractOption.Offer != "" && contractOption.Selected == true){
				return (
					<div className="row" key={index + contractOption.Key} >
						<div className={'col-md-7 col-lg-7 ' + displayClass}>
							<ContractItem key={contractOption.Key} onContractSelectionToggle={contractOption => contracts._handleChange(contractOption)} contractOption={contractOption} />
						</div>
						<div className={'col-md-5 col-lg-5 d-block-non-mobile-only ' + displayClass}>
							<div className="col-md-1 col-lg-1 triangleleft vertical-center">

							</div>
							<div className="col-md-11 col-lg-11 z-pal-bg-primary contractoffer z-pal-txt-primsup-2 corners centre-text">
								{contractOffers}
							</div>
						</div>
					</div>
				)
			}
			else{
				return (
					<div className="row" key={'0' + contractOption.Key}>
						<div className={'col-md-12' + displayClass}>
							<ContractItem key={contractOption.Key} onContractSelectionToggle={contractOption => contracts._handleChange(contractOption)} contractOption={contractOption} />
						</div>
					</div>
				)
			}
		});

		if (contractOffers.length > 0){
			return (
				<div style= {arbitraryStyle} >
					<div className="col-sm-12">
						<div className="radio">
							{contractItems}
						</div>
					</div>
				</div>
			);
		}
		else{
			return (
				<div className={'col-md-12 ' + displayClass}>
					<div className="radio">
						{contractItems}
					</div>
				</div>
			);
		}
	}
  
	render() {
        var a = this;

		return (
            <div>
                {a._hasContracts() ?
                    <div>
                        <h4>Select contract duration</h4>
                        <div className="row">
                            {a._renderItem(a)}
                        </div>
                    </div> :
                    <div className="row">
                        <div className="col loading-container">
                            <span>Gathering contract types</span>
							<img className="spinner" src="/content/images/loading.gif" height="30" width="30" alt="Gathering contract types"/>
                        </div>
                    </div>
                }
			</div>
		);
	}
};

export default ContractSelection;


// WEBPACK FOOTER //
// ./Scripts/App/Hosting/Components/ContractSelection.es6